/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_TaskPerformanceItemResponse_ } from '../models/PaginatedResponse_TaskPerformanceItemResponse_';
import type { TaskPerformanceItemCreateRequest } from '../models/TaskPerformanceItemCreateRequest';
import type { TaskPerformanceItemResponse } from '../models/TaskPerformanceItemResponse';
import type { TaskPerformanceItemsBulkUpdateRequest } from '../models/TaskPerformanceItemsBulkUpdateRequest';
import type { TaskPerformanceItemsBulkUpdateResponse } from '../models/TaskPerformanceItemsBulkUpdateResponse';
import type { TaskPerformanceItemUpdateRequest } from '../models/TaskPerformanceItemUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskPerformanceItemService {
    /**
     * Create Task Performance Item
     * 세부실행과제 성과 항목 생성
     *
     * 새로운 세부실행과제 성과 항목을 생성합니다.
     * @returns TaskPerformanceItemResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskPerformanceItem({
        requestBody,
    }: {
        requestBody: TaskPerformanceItemCreateRequest,
    }): CancelablePromise<TaskPerformanceItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/performance/item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Performance Items
     * 세부실행과제 성과 항목 목록 조회 및 검색
     *
     * 세부실행과제 성과 항목을 페이징하여 조회하거나 키워드로 검색합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항)
     * task_performance_id: 세부실행과제 성과 ID로 필터링 (선택사항)
     * @returns PaginatedResponse_TaskPerformanceItemResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskPerformanceItems({
        q,
        taskPerformanceId,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        taskPerformanceId?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_TaskPerformanceItemResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/performance/item',
            query: {
                'q': q,
                'task_performance_id': taskPerformanceId,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Performance Item
     * 세부실행과제 성과 항목 조회
     *
     * ID로 특정 세부실행과제 성과 항목을 조회합니다.
     * @returns TaskPerformanceItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskPerformanceItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<TaskPerformanceItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/performance/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Performance Item
     * 세부실행과제 성과 항목 정보 수정
     *
     * 특정 세부실행과제 성과 항목의 정보를 수정합니다.
     * @returns TaskPerformanceItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskPerformanceItem({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: TaskPerformanceItemUpdateRequest,
    }): CancelablePromise<TaskPerformanceItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/performance/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Performance Item
     * 세부실행과제 성과 항목 삭제
     *
     * 특정 세부실행과제 성과 항목을 삭제합니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskPerformanceItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/performance/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Performance Items Bulk
     * 세부실행과제 성과 항목 벌크 업데이트
     *
     * 성과 항목들을 한 번에 생성/수정/삭제합니다.
     * - ID가 없는 항목: 새로 생성
     * - ID가 있는 항목: 기존 항목 수정
     * - 요청에 없는 기존 항목: 삭제 처리
     *
     * Args:
     * performance_id: 성과 ID
     * data: 벌크 업데이트 요청 데이터
     * - items: 업데이트할 성과 항목 목록
     * - id: 항목 ID (없으면 신규 생성)
     * - name: 성과 항목명
     * - target_figure: 목표 수치
     * - done_figure: 완료 수치
     *
     * Returns:
     * 200: 업데이트 결과 (생성/수정/삭제 개수 및 최종 항목 목록)
     * 400: 잘못된 요청 데이터
     * 401: 인증 실패
     * 404: 성과를 찾을 수 없음
     * 500: 서버 내부 오류
     * @returns TaskPerformanceItemsBulkUpdateResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskPerformanceItemsBulk({
        performanceId,
        requestBody,
    }: {
        performanceId: string,
        requestBody: TaskPerformanceItemsBulkUpdateRequest,
    }): CancelablePromise<TaskPerformanceItemsBulkUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/performance/{performance_id}/items',
            path: {
                'performance_id': performanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
